import { init, register, waitLocale } from 'svelte-i18n';
import { localesMap } from '$lib/locales';
import z from 'zod';
import { zodTranslatedErrors } from '$lib/utils/validations';

const setLocale = async (locale: string) => {
	register('en', () => import('../../translations/en.json')); // fallback
	const hubLocale = localesMap[locale || 'en'];
	if (hubLocale !== 'en') {
		register(hubLocale, () => import(`../../translations/${hubLocale}.json`)); // fallback
	}
	void init({
		fallbackLocale: 'en',
		initialLocale: hubLocale,
	});

	await waitLocale();

	z.setErrorMap(zodTranslatedErrors);
};

export default setLocale;
